<!-- Large/card discount display-->
@if (size.toLowerCase() === 'large') {
  <div class="stairstep-price-display-container">
    @for (stairstep of stairsteps; track stairstep) {
      <div class="stairstep-large-records">
        <div class="stairstep-top-info">
          <span>{{ generateTopInfo(stairstep) }}</span>
        </div>
        @if (stairstep.price && stairstep.price > 0) {
          <glxy-frequency
            [value]="stairstep.price | priceInDollars : currencyCode : 'en-US'"
            [currencyCode]="currencyCode | resolveCurrencyCode : 'en-US'"
            [form]="Form.VERBOSE"
            [align]="align"
            [frequency]="frequency"
            [size]="size"
      [ngClass]="{
        'large-inner-frequency': size === 'large',
        'one-time-frequency': frequency === Frequency.ONE_TIME,
        'align-center': align.toLowerCase() === 'center'
      }"
          ></glxy-frequency>
        }
        @if (!stairstep.price || stairstep.price === 0) {
          <span>{{ freeLabel }}</span>
        }
      </div>
    }
    @if (shouldShowDialogLink) {
      <span class="dialog-link" (click)="openStepsDialog()">View all pricing</span>
    }
  </div>
}
<!-- Small/table/list discount display-->
@if (size.toLowerCase() === 'regular') {
  <div>
    @for (stairstep of stairsteps; track stairstep) {
      <div>
        <div style="text-align: left">
          {{ generateTopInfo(stairstep) }}
          <span style="float: right">
            @if (stairstep.price && stairstep.price > 0) {
              <glxy-frequency
                [value]="stairstep.price | priceInDollars : currencyCode : 'en-US'"
                [currencyCode]="currencyCode | resolveCurrencyCode : 'en-US'"
                [form]="Form.SHORT"
                [align]="align"
                [frequency]="frequency"
                [size]="size"
          [ngClass]="{
            'large-inner-frequency': size === 'large',
            'one-time-frequency': frequency === Frequency.ONE_TIME,
            'align-center': align.toLowerCase() === 'center'
          }"
              ></glxy-frequency>
            }
            @if (!stairstep.price || stairstep.price === 0) {
              <span>{{ freeLabel }}</span>
            }
          </span>
        </div>
      </div>
    }
  </div>
}
